import { axiosClient } from "../../../config/axios";

export const postGuestMessageApi = async (newMessage) => {
	const res = await axiosClient.post("/message/admin/new", newMessage);

	return res;
};

export const postGuestImageApi = async (payload) => {
	const res = await axiosClient.post("/upload/admin/file", payload);
	return res;
};

export const loadChatsApi = async (skip) => {

	const res = await axiosClient.get("/messages/admin/load/" + skip);
	return res;
};
